var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.1667L15.5 8.61114V7.1667C15.5 6.59206 15.2629 6.04096 14.841 5.63463C14.419 5.2283 13.8467 5.00003 13.25 5.00003H5.25C4.65326 5.00003 4.08097 5.2283 3.65901 5.63463C3.23705 6.04096 3 6.59206 3 7.1667V15.8334C3 16.408 3.23705 16.9591 3.65901 17.3654C4.08097 17.7718 4.65326 18 5.25 18H13.25C13.8467 18 14.419 17.7718 14.841 17.3654C15.2629 16.9591 15.5 16.408 15.5 15.8334V14.3889L21 15.8334V7.1667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCamera);
export default __webpack_public_path__ + "static/media/small-camera.f82a59a3.svg";
export { ForwardRef as ReactComponent };